export const VehicleWarning = `운송해야할 물품의 정보를 입력해 주세요.`;

export const QuickAddressWarning = `보내는 분과 받는 분의 주소를 설정해 주세요. 경유지가 있는 경우, 1개까지 추가 가능합니다.
<div class="warning">(!) 현재 퀵 서비스는 수도권 지역 (서울, 경기, 인천)에만 적용되며, 점차 서비스 지역을 확대하 나갈 예정입니다. <br>(!) 보내는 분은 휴대전화번호를 입력해주세요. 예약하신 퀵 서비스의 상태를 문자로 확인 할 수 있습니다.</div>`;

export const QuickReservationWarning = `<div style=color:#FF8787;font-size:14px>(!) 배송 과정에서 다양한 이유로, 운임이 변경될 수 있습니다. <br>(!) 운임이 변경될 경우, 고고엑스 고객센터(1588-3047)에서 안내 전화가 진행될 수 있습니다.</div>`;

export const QuickReservation = `<div>모든 필수 정보 설정 후, 예상 운임을 확인해주세요.<br>예상 운임 확인 후, 반드시 약관 동의 후 주문 완료해주세요.<br/><div style=color:#FF8787;font-size:12px>(!) 최대적재량을 넘어 회차되는 경우 회차비용 5,000원이 발생하니 유의하세요.</div></div>`;

export const QuickReservationAgreement = `<div>퀵대장 서비스를 이용하기 위해서, 아래 이용 약관에 동의해주셔야 합니다.<br>반드시 내용을 숙지한 후, 서비스를 신청해주시길 바랍니다.</div>`;

export const ServicePostMessage = `<div>현재 식권대장을 사용할 수 없습니다. 먼저 아래 양식을 통해 서비스 신청해주시면,<br>식권대장 담당자가 신속히 연락드리도록 하겠습니다.</div>`;

export const ServicePostReception = `<div>현재 서비스 사용 신청이 접수되어, 담당자가 확인 중입니다.</div>`;
